export const convertQuantity = (quantity, fromUnit, toUnit) => {
  const normalized = (unit) =>
    (unit || '')
      .toString()
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .replace('per ', '')
      .trim()

  const factors = {
    quintal: 100,
    mt: 1000,
    'metric ton': 1000,
    ton: 1000,
    tonnes: 1000,
    tonne: 1000,
    kg: 1,
    kgs: 1,
    trip: 1,
  }

  const from = normalized(fromUnit)
  const to = normalized(toUnit)

  if (to === 'trip') {
    return quantity
  }

  if (!factors[from] || !factors[to]) {
    console.error('Unknown unit conversion', fromUnit, toUnit)
    return quantity
  }

  if (from === to) {
    return quantity
  }

  const quantityInKg = quantity * factors[from]
  return quantityInKg / factors[to]
}
